import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';
import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi.ts';
import { IncidentCardDetailsInfoBodyResType } from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/body/getIncidentCardDetailsInfoBody.types';

export const incidentDetailsCardBodyDataGenerator = (
  data: IncidentCardDetailsInfoBodyResType,
): DetailCardItemData[] => [
  {
    type: 'default',
    keyName: 'استان - شهر',
    value: `${data.visit_county.name}, ${data.visit_province.name}`,
    hasBullet: true,
  },

  {
    type: 'default',
    keyName: 'تاریخ تشکیل:',
    value: convertTimestampToShamsi(data.creation_date),
    hasBullet: true,
  },
  {
    type: 'default',
    keyName: 'بیمه‌گر',
    value: data.insurance.fa_const,
    hasBullet: true,
  },
];
